import React from 'react'
const AccessManagementAppContext = React.createContext({})

export default AccessManagementAppContext
